import React from 'react';
import { Link } from 'react-router-dom';
import { FlameIcon } from 'lucide-react';
export const Header: React.FC = () => {
  return <header className="bg-background-light py-4 px-6 flex justify-between items-center shadow-lg" data-id="element-53">
      <Link to="/" className="flex items-center gap-2 text-primary font-bold text-2xl" data-id="element-54">
        <FlameIcon className="h-8 w-8" data-id="element-55" />
        <span data-id="element-56">IBD Rant</span>
      </Link>
      <nav className="flex gap-4 items-center" data-id="element-57">
        <Link to="/" className="text-text-primary hover:text-primary transition-colors" data-id="element-58">
          Home
        </Link>
        <Link to="/hall-of-rage" className="text-text-primary hover:text-primary transition-colors" data-id="element-59">
          Hall of Rage
        </Link>
      </nav>
    </header>;
};